export default __webpack_public_path__ + "static/media/icn_freighter.c4ac078f.svg";